import axios from "../axiosInstance";
import {
  FetchChapterActivitiesParams,
  FetchChapterActivitiesResponse,
} from "./types";

export const fetchChapterActivities = async (
  params: FetchChapterActivitiesParams = {},
): Promise<FetchChapterActivitiesResponse> => {
  const response = await axios.get<FetchChapterActivitiesResponse>(
    "/api/private/chapter-activities",
    { params },
  );
  return response.data;
};
